










import { Vue, Component } from 'vue-property-decorator';
import Contactos from '@/pantallas/Contactos/Contactos.vue';

@Component({
  components: { Contactos },
})
export default class ContactosPantalla extends Vue {}
